import React, {useEffect, useRef, useState} from 'react';
import Portal from "../../utils/Portal";
import responseHandler from "../../services/responseHandler";
import useAxiosIntercept from "../../hooks/useAxiosIntercept";

function CustomerAssignPackage(props) {
    const [open, setOpen] = useState(false);
    const axiosPrivate = useAxiosIntercept();
    const [packageData, setPackageData] = useState([]);
    const [selectedPackage, setSelectedPackage] = useState({});
    const ref = useRef(true);
    const [message, setMessage] = useState("");

    const getPackageList = async () => {
        try{
            let payload={};
            payload.status= 1;
            payload.brand_id = props.data.brand_id;
            payload.model_id = props.data.model_id;
            payload.variant_id = props.data.variant_id;
            const response = await axiosPrivate.post(process.env.REACT_APP_GET_PACKAGES_URL, payload);
            if(response?.data?.status == 200){
                if(response?.data?.response?.data?.packages){
                    setPackageData(response?.data?.response?.data?.packages);
                }
            }
            else{
                console.log(`API Error: ${JSON.stringify(response?.data?.response)}`);
            }
        }
        catch (error){
            return responseHandler(error, "NETWORK_ERROR");
        }
    }

    const mapUserPackage = async () => {
        try {
            let payload = {};
            if(props.user_id){
                payload.customer_user_id = props.user_id;
            }
            if(props.data.vehicle_id){
                payload.vehicle_id = props.data.vehicle_id;
            }

            payload.package_id = selectedPackage.id;

            const response = await axiosPrivate.post(process.env.REACT_APP_BOOKING_BUY_PACKAGE, payload);
            if(response?.data?.response){
                if(response.data.message){
                    props.close();
                    props.update();
                    // navigate("/customers", {state:{message:response.data.message}});
                    props.setSuccessMessage(response.data.message);
                }
            }
            else{
                console.log("something went wrong");
            }
        }
        catch (error){
            console.log(error);
        }
    }

    let assignPackage = () => {
        if(selectedPackage.id){
            mapUserPackage();
        }
        else{
            setMessage("Select package")
            setTimeout(()=>{
                setMessage("");
            },3000)
        }
    }

    useEffect(()=>{
        if(ref.current){
            ref.current= false;
            getPackageList();
        }
    },[])

    return (
        <Portal>
            <div id="myModal" className="popup_box open">
                <div className="model_box">
                    <div
                        className="model_box_child prd_ns"
                        id="assignPackage"
                        style={{ width: 300 }}
                    >
                        <div className="ap_heading">
                            <h4>
                                Assign new package
                                <span className="material-symbols-rounded black close_model" onClick={()=>{
                                    props.close();
                                }}>
                                    close
                                </span>
                            </h4>
                        </div>
                        <div className="contentSection">
                            <section className="assignPromoP dForm">
                                <div className="promoText customer">
                                    {props.name ? <h4>{props.name}</h4> : <h4>Guest</h4>}
                                    <p>{props.data.model_name} {props.data.brand_name} {props.data.model_name} {props.data.variant_name}</p>
                                </div>
                                <div className="fieldGroup">
                                    <label>Select package</label>
                                    <div className="multiOption">
                                        <div
                                            className={open ? "selectBox fullW open" : "selectBox fullW"}
                                            onClick={()=>{setOpen(prevState => !prevState)}}
                                        >
                                            {!selectedPackage.id ?

                                                <p>
                                                    Select package
                                                    <i className="material-symbols-rounded grey">expand_more</i>
                                                </p>
                                                :
                                                <p>
                                                {selectedPackage.name}
                                                    <i className="material-symbols-rounded grey">expand_more</i>
                                                </p>
                                            }
                                            <div className="selectDrop relP">
                                                <ul className="dropMenu">

                                                    {packageData.map((data) => {
                                                        return(
                                                            <li onClick={()=>{setSelectedPackage({"id" : data.package_id, "name" : data.package_name}); }} className="selected" key={data.package_id}>
                                                                <a href={void(0)}>
                                                                    {data.package_name}
                                                                    {data.package_id == selectedPackage.id && <i className="material-symbols-rounded">done</i>}
                                                                </a>
                                                            </li>
                                                        )
                                                    })}
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </section>
                            {
                                message!="" &&
                                <div>
                                    <span className="error">
                                        <span className="material-symbols-rounded error mt-xs fill">
                                            info
                                        </span>
                                        {message}
                                    </span>
                                </div>
                            }
                            <div className="actionButtons mt-24">
                                <span onClick={assignPackage}>
                                    <a href="javascript:void(0);" className="btn prim fullW">
                                      Assign package
                                    </a>
                                </span>
                            </div>
                        </div>
                    </div>

                </div>
            </div>

        </Portal>

    );
}

export default CustomerAssignPackage;